(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Ambassadors"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.currentScript
    ? document.currentScript.closest('.amb-section') || document.querySelector('.amb-section')
    : document.querySelector('.amb-section');
  if (!section) return;

  var track    = section.querySelector('.amb-track');
  var cards    = Array.from(section.querySelectorAll('.amb-card'));
  var prevBtn  = section.querySelector('.amb-arrow--prev');
  var nextBtn  = section.querySelector('.amb-arrow--next');
  var dots     = Array.from(section.querySelectorAll('.amb-dot'));
  var modal    = document.getElementById('amb-modal');
  var frame    = document.getElementById('amb-modal-frame');
  var closeBtn = modal && modal.querySelector('.amb-modal-close');
  var backdrop = modal && modal.querySelector('.amb-modal-backdrop');

  /* ── Embed URL builder ───────────────────────────────── */
  function embedUrl(raw, autoplay, muted, loop) {
    if (!raw) return null;
    var yt = raw.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|shorts\/|embed\/))([a-zA-Z0-9_-]{11})/);
    var vm = raw.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (yt) {
      var id = yt[1];
      return 'https://www.youtube.com/embed/' + id + '?autoplay=' + (autoplay?1:0) +
        '&mute=' + (muted?1:0) + '&loop=' + (loop?1:0) + (loop ? '&playlist=' + id : '') + '&rel=0&playsinline=1';
    }
    if (vm) {
      return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=' + (autoplay?1:0) +
        '&muted=' + (muted?1:0) + '&loop=' + (loop?1:0) + '&title=0&byline=0&portrait=0';
    }
    return null;
  }

  /* ── Modal ───────────────────────────────────────────── */
  function openModal(card) {
    var url = embedUrl(
      card.dataset.videoUrl,
      card.dataset.autoplay === 'true',
      card.dataset.muted    === 'true',
      card.dataset.loop     === 'true'
    );
    if (!url || !modal) return;
    frame.innerHTML = '<iframe src="' + url + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    frame.innerHTML = '';
    document.body.style.overflow = '';
  }

  cards.forEach(function(c) { c.addEventListener('click', function() { openModal(c); }); });
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (backdrop) backdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeModal(); });

  /* ── Arrow scroll ────────────────────────────────────── */
  if (prevBtn && nextBtn && track) {
    function cardWidth() {
      var c = track.querySelector('.amb-card');
      return c ? c.offsetWidth + parseInt(getComputedStyle(track).columnGap || 12) : 300;
    }
    prevBtn.addEventListener('click', function() { track.scrollBy({ left: -cardWidth(), behavior: 'smooth' }); });
    nextBtn.addEventListener('click', function() { track.scrollBy({ left:  cardWidth(), behavior: 'smooth' }); });

    function syncArrows() {
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    track.addEventListener('scroll', syncArrows, { passive: true });
    syncArrows();
  }

  /* ── Dot sync ────────────────────────────────────────── */
  if (dots.length && track) {
    dots[0] && dots[0].classList.add('is-active');
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var idx = cards.indexOf(entry.target);
          dots.forEach(function(d, i) {
            d.classList.toggle('is-active', i === idx);
          });
        }
      });
    }, { root: track, threshold: 0.6 });
    cards.forEach(function(c) { io.observe(c); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
